import { render } from "./ProgramComponent.vue?vue&type=template&id=4330d806"
import script from "./ProgramComponent.vue?vue&type=script&lang=js"
export * from "./ProgramComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__